export enum TabState {
  Default = 'DEFAULT',
  Empty = 'EMPTY',
}
